import { isTabletUp } from '../../scripts/helpers';
import { isTabletLandscapeUp } from '../../scripts/helpers';

class CardsList {
  constructor() {

    if(document.querySelector('.cards-list--ebooks') != null && document.querySelector('.cards-list--ebooks') != undefined) {
      this.setEventsBooks();
    }

    if(document.querySelector('.cards-list--ebooks-small') != null && document.querySelector('.cards-list--ebooks-small') != undefined) {
      this.setEventsBooksSmall();
    }

    if(document.querySelector('.cards-list--courses') != null && document.querySelector('.cards-list--courses') != undefined) {
      this.setEventsCourses();
    }

    if(document.querySelector('.cards-list--public-complains') != null && document.querySelector('.cards-list--public-complains') != undefined) {
      this.setEventsPublicComplains();
    }

    if(document.querySelector('.cards-list--companies') != null && document.querySelector('.cards-list--companies') != undefined) {
      this.setEventsCompanies();
    }

    if(document.querySelector('.cards-list--companies--small') != null && document.querySelector('.cards-list--companies--small') != undefined) {
      this.setEventsCompaniesSmall();
    }

    if(document.querySelector('.cards-list--tests') != null && document.querySelector('.cards-list--tests') != undefined) {
      this.setEventsTests();
    }

  }

  setEventsBooks() {
    var cardsListEbooks = document.querySelectorAll('.cards-list--ebooks');

    if(typeof(cardsListEbooks) != 'undefined' && cardsListEbooks != null) {
      if(!isTabletUp()) {
        $('.cards-list--ebooks').slick({
          dots: false,
          infinite: false,
          speed: 500,
          slidesToShow: 7,
          slidesToScroll: 1,
          arrows: true,
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 6,
              }
            },
            {
              breakpoint: 1047,
              settings: {
                slidesToShow: 5,
              }
            }
          ]
        });
      }
    }     

    var cardsListEbooksSmall = document.querySelectorAll('.cards-list--ebooks-small');

    if(typeof(cardsListEbooksSmall) != 'undefined' && cardsListEbooksSmall != null) {
      if(!isTabletUp()) {
        $('.cards-list--ebooks-small').slick({
          dots: false,
          infinite: false,
          speed: 500,
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: true
        });
      }
    }  
  }

  setEventsBooksSmall() {
    var cardsListEbooksSmall = document.querySelectorAll('.cards-list--ebooks-small');

    if(typeof(cardsListEbooksSmall) != 'undefined' && cardsListEbooksSmall != null) {
      if(!isTabletUp()) {
        $('.cards-list--ebooks-small').slick({
          dots: false,
          infinite: false,
          speed: 500,
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: true,
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 2
              }
            }
          ]
        });
      }
    }  
  }

  setEventsCourses() {
    var cardsListCourses = document.querySelectorAll('.cards-list--courses');

    if(typeof(cardsListCourses) != 'undefined' && cardsListCourses != null) {
      if(!isTabletUp()) {
        $('.cards-list--courses').slick({
          dots: false,
          infinite: false,
          speed: 500,
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: true,
        });
      }
    }     
  }

  setEventsPublicComplains() {
    var cardsListPublicComplains = document.querySelectorAll('.cards-list--public-complains');

    if(typeof(cardsListPublicComplains) != 'undefined' && cardsListPublicComplains != null) {
      if(!isTabletLandscapeUp()) {
        $('.cards-list--public-complains').slick({
          dots: false,
          infinite: false,
          speed: 500,
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: true,
          responsive: [
            {
              breakpoint: 1060,
              settings: {
                slidesToShow: 3,
              }
            },
            {
              breakpoint: 900,
              settings: {
                slidesToShow: 4,
              }
            }
          ]
        });
      }
    }     
  }

  setEventsCompanies() {
    var cardsListCompanies = document.querySelectorAll('.cards-list--companies');

    if(typeof(cardsListCompanies) != 'undefined' && cardsListCompanies != null) {
      if(!isTabletLandscapeUp()) {
        $('.cards-list--companies').slick({
          dots: false,
          infinite: false,
          speed: 500,
          slidesToShow: 7,
          slidesToScroll: 1,
          arrows: true,
          responsive: [
            {
              breakpoint: 1060,
              settings: {
                slidesToShow: 5,
              }
            }
          ]
        });
      }
    }     
  }

  setEventsCompaniesSmall() {
    var cardsListCompaniesSmall = document.querySelectorAll('.cards-list--companies--small');

    if(typeof(cardsListCompaniesSmall) != 'undefined' && cardsListCompaniesSmall != null) {
      if(!isTabletLandscapeUp()) {
        $('.cards-list--companies--small').slick({
          dots: false,
          infinite: false,
          speed: 500,
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: true,
          responsive: [
            {
              breakpoint: 1060,
              settings: {
                slidesToShow: 5,
              }
            }
          ]
        });
      }
    }     
  }

  setEventsTests() {
    var cardsListTests = document.querySelectorAll('.cards-list--tests');

    if(typeof(cardsListTests) != 'undefined' && cardsListTests != null) {
      if(!isTabletLandscapeUp()) {
        $('.cards-list--tests').slick({
          dots: false,
          infinite: false,
          speed: 500,
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: true,
          responsive: [
            {
              breakpoint: 1280,
              settings: {
                slidesToShow: 4,
              }
            }
          ]
        });
      }
    }     
  }
    
}

$(document).ready(function() {
  const cardsList = new CardsList();
});
